import { useTranslation } from '@gimlite/common';
import { Main, useStoreUIV2 } from '@gimlite/ui-v2';
import GC from '@gimlite/ui-v2/assets/logo/GC_full';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
const MainUse = observer(() => {
  const { SSOStore } = useStoreUIV2();
  const navigate = useNavigate();
  const me = SSOStore.user;

  return me ? (
    <Main
      onNavigate={(key: string) => {
        navigate(key);
      }}
      logo={GC()}
      mode={'free'}
    />
  ) : null;
});

export default MainUse;
